import React, { createContext, useEffect, useState } from 'react'
import httpCommon from 'src/http-common';

// Default context value with no-op functions to prevent "setFrom is not a function" errors
const defaultContextValue = {
  from: null,
  setFrom: () => {},
  to: new Date(),
  setTo: () => {},
  toogleApi: false,
  setToogleApi: () => {},
  clearDateFilters: () => {},
};

export const DateContext = createContext(defaultContextValue);

function DateContextProvider({children}) {
  const today = new Date();
  const siteCode = localStorage.getItem('siteCode');
  
  // Initialize state with values from localStorage if available
  const getStoredDate = (key, defaultValue) => {
    const stored = localStorage.getItem(key);
    if (stored && stored !== 'null' && stored !== 'undefined') {
      return new Date(stored);
    }
    return defaultValue;
  };

  const [from, setFromState] = useState(() => getStoredDate('dateFilter_from', null));
  const [to, setToState] = useState(() => getStoredDate('dateFilter_to', today));
  const [toogleApi, setToogleApi] = useState(false);

  // Wrapper functions to save to localStorage when dates change
  const setFrom = (date) => {
    setFromState(date);
    if (date) {
      localStorage.setItem('dateFilter_from', date.toISOString());
    } else {
      localStorage.removeItem('dateFilter_from');
    }
  };

  const setTo = (date) => {
    setToState(date);
    if (date) {
      localStorage.setItem('dateFilter_to', date.toISOString());
    } else {
      localStorage.removeItem('dateFilter_to');
    }
  };

  // Clear date filters (call this on logout)
  const clearDateFilters = () => {
    localStorage.removeItem('dateFilter_from');
    localStorage.removeItem('dateFilter_to');
    setFromState(null);
    setToState(today);
  };

  // Test function for debugging (can be called from browser console)
  const testDatePersistence = () => {
  };

  // Make test function available globally for debugging
  useEffect(() => {
    window.testDatePersistence = testDatePersistence;
    return () => {
      delete window.testDatePersistence;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [from, to]);

  const fetchFromDay = async() => {
    try {
      const response = await httpCommon.get(
        `/get_from_to.php?site_cd=${siteCode}`
      );
  
      if (response.data.status === 'SUCCESS') {
        const date = response.data.data;
        
        // Only set the from date if it's not already stored in localStorage
        const storedFrom = localStorage.getItem('dateFilter_from');
        if (!storedFrom || storedFrom === 'null' || storedFrom === 'undefined') {
          setFrom(new Date(date));
        } else {
        }
        
        localStorage.setItem("firstFrom", response.data.data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  
  // Handle Date useEffect - only fetch initial date if not in localStorage
  useEffect(() => {
    const storedFrom = localStorage.getItem('dateFilter_from');
    if (!storedFrom || storedFrom === 'null' || storedFrom === 'undefined') {
      fetchFromDay();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Listen for logout event to clear date filters
  useEffect(() => {
    const handleLogout = () => {
      clearDateFilters();
    };

    // Listen for custom logout event
    window.addEventListener('userLogout', handleLogout);
    
    // Also listen for storage changes in case logout happens in another tab
    const handleStorageChange = (e) => {
      if (e.key === 'userLoggedOut' && e.newValue === 'true') {
        clearDateFilters();
        localStorage.removeItem('userLoggedOut');
      }
    };
    
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('userLogout', handleLogout);
      window.removeEventListener('storage', handleStorageChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DateContext.Provider value={{ 
      from, 
      setFrom, 
      to, 
      setTo, 
      toogleApi, 
      setToogleApi,
      clearDateFilters 
    }}>
      {children}
    </DateContext.Provider>
  )
}

export default DateContextProvider

